<template>
  <v-dialog v-model="dialog" persistent width="1300">
    <v-card>
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>refresh</v-icon>Movilidad</v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0 px-1">
        <v-container grid-list-md style="min-width:100%" class="py-0"> 
          <v-layout wrap row>
            <v-flex xs12 v-if="form.id_tipo_justificacion != 14">
              <v-select
                @click.native="obtenerTipoJustificaciones()"
                :items="tipo_movimientos"
                item-text="descripcion"
                :item-value="val => parseInt(val.id)"
                label="Tipo de movimiento"
                v-model="form.id_tipo_justificacion"
                :rules="$validate(['required'])"
                required
                :disabled="form.editar"
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="form.id_tipo_justificacion == 14">
              <v-select
                @click.native="obtenerTipoJustificaciones()"
                :items="tipo_movimientos"
                item-text="descripcion"
                :item-value="val => parseInt(val.id)"
                label="Suspensión"
                v-model="form.id_tipo_justificacion"
                :rules="$validate(['required'])"
                required
                disabled
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                v-if="form.id_tipo_justificacion == 13"
                @click.native="obtenerTipoJustificacionesR()"
                :items="tipo_movimientos_r"
                item-text="descripcion"
                :item-value="val => parseInt(val.id)"
                label="Tipo de movimiento."
                v-model="form.id_tipo_justificacion_r"
                :rules="$validate(['required'])"
                required
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <retiro
        :id_tipo_justificacion="form.id_tipo_justificacion_r"
        v-if="form.id_tipo_justificacion == 13"
        :funcionario="funcionario"
        :data="form"
      />
      <cambio-item
        :id_tipo_justificacion="form.id_tipo_justificacion"
        v-if="form.id_tipo_justificacion == 1"
        :funcionario="funcionario"
        :unidades="unidades"
        :puestos="puestos"
        :cargos="cargos"
        :data="form"
      />
      <comision-servicio
        :id_tipo_justificacion="form.id_tipo_justificacion"
        v-if="form.id_tipo_justificacion == 2"
        :funcionario="funcionario"
        :unidades="unidades"
        :puestos="puestos"
        :cargos="cargos"
        :data="form"
      />
      <suspencion
        :id_tipo_justificacion="form.id_tipo_justificacion"
        v-if="form.id_tipo_justificacion == 14"
        :funcionario="funcionario"
        :unidades="unidades"
        :puestos="puestos"
        :cargos="cargos"
        :data="form"
      />
      <comision-interinato
        :id_tipo_justificacion="form.id_tipo_justificacion"
        v-if="form.id_tipo_justificacion == 11"
        :funcionario="funcionario"
        :unidades="unidades"
        :puestos="puestos"
        :cargos="cargos"
        :data="form"
      />

      <nueva-asignacion
        :id_tipo_justificacion="form.id_tipo_justificacion"
        v-if="form.id_tipo_justificacion == 7"
        :funcionario="funcionario"
        :unidades="unidades"
        :puestos="puestos"
        :cargos="cargos"
        :data="form"
      />
      <reestructuracion
        :id_tipo_justificacion="form.id_tipo_justificacion"
        v-if="form.id_tipo_justificacion == 15"
        :funcionario="funcionario"
        :unidades="unidades"
        :puestos="puestos"
        :cargos="cargos"
        :data="form"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import Retiro from "../components/Retiro.vue";
import CambioItem from "../components/CambioItem.vue";
import ComisionServicio from "../components/ComisionServicio.vue";
import Suspencion from "../components/Suspencion.vue";
import ComisionInterinato from "../components/ComisionInterinato.vue";
import NuevaAsignacion from "../components/NuevaAsignacion.vue";
import Reestructuracion from "../components/Reestructuracion.vue";

export default {
  components: {
    Retiro,
    CambioItem,
    ComisionServicio,
    Suspencion,
    ComisionInterinato,
    NuevaAsignacion,
    Reestructuracion
  },
  mixins: [validate],
  data() {
    return {
      dialog: false,
      form: {},
      tipo_movimientos: [],
      tipo_movimientos_r: [],
      funcionario: {},
      unidades: [],
      cargos: [],
      puestos: [],
      id_tipo_justificacion_r: null
    };
  },
  async mounted() {
    this.obtenerTipoJustificaciones();
    await this.obtenerTipoJustificacionesR();
    this.obtenerUnidades();
    this.obtenerCargos();
    this.obtenerPuestos();
    this.$bus.$on("openDialogCrearMovilidad", item => {
      this.funcionario = item;
      this.dialog = true;
    });
    this.$bus.$on("closeDialogCrearMovilidad", () => {
      this.close();
    });
    this.$bus.$on("openDialogEditarMovilidad", async item => {
      this.funcionario = item.funcionario;
      this.funcionario.id_movilidad_actual = item.id;
      this.form = item;
      this.form.id_unidad = item.id_unidad;
      this.form.nro_item = item.nro_item;

      if (
        this.form.id_tipo_justificacion == 5 ||
        this.form.id_tipo_justificacion == 6 ||
        this.form.id_tipo_justificacion == 10
      ) {
        this.form.id_tipo_justificacion_r = this.form.id_tipo_justificacion;
        this.form.id_tipo_justificacion = 13;
      }
      if (this.form.id_tipo_justificacion == 11) {
        this.form.nro_item = await this.obtenerNroItemPuesto(1);
        this.form.id_puesto = await this.obtenerNroItemPuesto(2);
        this.form.id_unidad = await this.obtenerNroItemPuesto(3);
      }
      this.dialog = true;
    });
  },
  methods: {
    async obtenerNroItemPuesto(valor) {
      try {
        let res = await this.$service.graphql({
          query: `
              query{
              runQuery(consulta: "SELECT i.id_movilidad ,i.id_item,i.id_puesto,i.id_unidad from movilidad.interinato i where i.id_movilidad =${this.form.id}"){
              respuesta
              }
              }
              `
        });
        if (res.runQuery.respuesta) {
          if (valor == 1) {
            return res.runQuery.respuesta[0].id_item;
          }
          if (valor == 2) {
            return res.runQuery.respuesta[0].id_puesto;
          }
          if (valor == 3) {
            return res.runQuery.respuesta[0].id_unidad;
          }
          // this.nro_item = res.runQuery.respuesta[0].id_item;
          // console.log("sii",res.runQuery.respuesta[0].id_item+"")
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerTipoJustificaciones() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
            tipoJustificacions(tipo: "activo"){
            rows{
            id
            descripcion
            id_estado
            }
            }
            }
            `
        });
        this.tipo_movimientos = res.tipoJustificacions.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerTipoJustificacionesR() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
            tipoJustificacions(tipo: "retiro"){
            rows{
            id
            descripcion
            id_estado
            }
            }
            }
            `
        });
        this.tipo_movimientos_r = res.tipoJustificacions.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerUnidades() {
      try {
        let res = await this.$service.graphql({
          query: `
                query{
                unidads(id_estado: 17, id_entidad: 35){
                rows{
                id
                nombre_unidad
                }
                }
                }
                `
        });
        this.unidades = res.unidads.rows;
        //   this.obtenerOrganigrama(res.unidads.rows);
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerPuestos() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
            puestos{
            rows{
            id
            denominacion
            }
            }
            }
            `
        });
        this.puestos = res.puestos.rows;
      } catch (error) {
        console.log(error);
      }
    },

    async obtenerCargos() {
      try {
        let res = await this.$service.graphql({
          query: `
              query{
              vItemCargos(libre: 1){
              rows{
              id_item
              nro_item
              nombre_unidad
              cargo
              id_cargo
              sueldo
              libre
              id_unidad
              padres_unidad
              }
              }
              }
              `
        });
        this.cargos = res.vItemCargos.rows;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.form = {};
      this.funcionario = {};
      this.$bus.$emit("closeDialogMovilidad");
      this.dialog = false;
    }
    // treeObtenerOrganigrama(unidadesVec) {
    //   if (unidadesVec.length === 0) return [];
    //   if (unidadesVec.length === 3)
    //     return [
    //       {
    //         id: 1,
    //         name: unidadesVec[2],
    //         icon: "location_city",
    //         children: [
    //           {
    //             id: 2,
    //             name: unidadesVec[1],
    //             icon: "business",
    //             children: [
    //               {
    //                 name: unidadesVec[0],
    //                 icon: "home",
    //               },
    //             ],
    //           },
    //         ],
    //       },
    //     ];
    // },
    // obtenerOrganigrama(unidades) {
    //   Promise.all(
    //     unidades.map((uni) => {
    //       return this.$service.graphql({
    //         query: `
    //           query{
    //           fnPadresUnidad(id_unidad: ${parseInt(uni.id)}, id_entidad: 35){
    //           respuesta
    //           }
    //           }
    //           `,
    //       });
    //     })
    //   )
    //     .then((organigramas) => {
    //       const unidadeConOrganigrama = unidades.map((uni, index) => {
    //         return {
    //           ...uni,
    //           organigrama: this.treeObtenerOrganigrama(
    //             organigramas[index].fnPadresUnidad.respuesta.split("|")
    //           ),
    //         };
    //       });
    //       this.unidades = unidadeConOrganigrama;
    //     })
    //     .catch((err) => console.log(err));
    // },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/CrearMovilidad.vue